import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import '../../RowMenu/RowMenu.js';
import RowContextMenu from '../../RowMenu/RowContextMenu.js';
import StyledTableDataRow from './StyledTableDataRow.js';
import { useClick } from './hooks/useClick.js';
import { useDnd } from './hooks/useDnd.js';
import { useContextMenu } from './hooks/useContextMenu.js';
import { useVisibleRows } from './hooks/useVisibleRows.js';

const DragDummyPreview = styled('span') `
  color: transparent;
  opacity: 0;
`;
const Skeleton = styled('span') `
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.N60.main} center;
  display: block;
  width: 100%;
  margin: 12px;
`;
const TableDataRow = React__default.memo((_a) => {
    var { row, rowHeight = 62, onRowClick, onRowDoubleClick, onRowsDrag, canDropOnRow, isRowHidden, onRowFocus, selectedRowIds, getRowMenu, denseRowContextMenu, clickedRowId, checked, children, width, scrollbarWidth, enableRowDragging, enableRowClickSelection, enableCheckboxSelection, columnResizingShift, rtl, index, itemsCount, skeleton = jsx(Skeleton, {}), loading, onRowContextMenuOpen, onRowContextMenuClose } = _a, rest = __rest(_a, ["row", "rowHeight", "onRowClick", "onRowDoubleClick", "onRowsDrag", "canDropOnRow", "isRowHidden", "onRowFocus", "selectedRowIds", "getRowMenu", "denseRowContextMenu", "clickedRowId", "checked", "children", "width", "scrollbarWidth", "enableRowDragging", "enableRowClickSelection", "enableCheckboxSelection", "columnResizingShift", "rtl", "index", "itemsCount", "skeleton", "loading", "onRowContextMenuOpen", "onRowContextMenuClose"]);
    const isRowClicked = useMemo(() => row.id === clickedRowId, [clickedRowId, row.id]);
    const hidden = useMemo(() => isRowHidden && isRowHidden(row), [isRowHidden, row]);
    if (!enableCheckboxSelection && enableRowDragging) {
        enableRowDragging = true;
    }
    const { render } = useVisibleRows({ index, itemsCount });
    const { contextMenu, onClose, onContextMenu } = useContextMenu();
    const { onClick } = useClick({ isRowClicked, row, onRowClick, onRowDoubleClick });
    const { previewRef, drag, isDragged, isOver, canDrop, item, drop } = useDnd({
        canDropOnRow,
        row,
        enableRowDragging,
        checked,
        selectedRowIds,
        enableCheckboxSelection,
        width,
        onRowsDrag,
    });
    return (jsxs(Fragment, { children: [render && enableRowDragging && jsx(DragDummyPreview, Object.assign({ ref: previewRef }, { children: "dummy" })), jsxs(StyledTableDataRow
            // @ts-ignore
            , Object.assign({ 
                // @ts-ignore
                component: "div", "aria-label": "row", ref: (x) => {
                    drop(x);
                    drag(x);
                }, onContextMenu: onContextMenu, rowHeight: rowHeight, onFocus: () => onRowFocus === null || onRowFocus === void 0 ? void 0 : onRowFocus(row), rowWidth: columnResizingShift ? undefined : width - scrollbarWidth, onClick: onClick, canDrop: canDrop, hidden: hidden, rtl: rtl, isDragged: isDragged, isOver: isOver, selected: row.isSelected, isDragging: item !== null, isClicked: enableRowClickSelection && isRowClicked, skeleton: !render || loading, forceHover: contextMenu !== null }, rest, { children: [render && children, render && getRowMenu && (jsx(RowContextMenu, { contextMenu: contextMenu, denseRowMenu: denseRowContextMenu, onClose: onClose, getRowMenu: getRowMenu, onRowContextMenuOpen: onRowContextMenuOpen, onRowContextMenuClose: onRowContextMenuClose, row: row, rtl: rtl })), !render && skeleton] }))] }));
});
TableDataRow.displayName = 'TableDataRow';

export { TableDataRow as default };
//# sourceMappingURL=TableDataRow.js.map
